export default "__VITE_ASSET__51d56682__"